<template>
    <div class="file-upload">

        <a-upload :action="action" :file-list="fileLists" :before-upload="beforeUpload" :custom-request="customRequest"
                  @preview="onPreview" @change="onChange" v-bind="$attrs"
                  :accept="isPdf ? '.pdf' :isPdfImg?'.pdf,.png,.jpg,.jpeg,gif': ''"
                  :remove="removeHandle">
            <template v-if="fileLists.length < count">
                <a-button v-if="showBtn" :disabled="loading">
                    <loading-outlined v-if="loading"/>
                    <upload-outlined v-else/>
                    {{ names }}
                </a-button>
                <div style="margin-top:9px" v-if="!showBtn&&fileLists.length===0">暂无</div>
            </template>
        </a-upload>
        <br/>
        <a-progress style="width: 50%" v-if="loading" :percent="percent" />
    </div>
</template>

<script>
import {computed, ref, toRefs, watch} from "vue";
import {message} from "ant-design-vue";
import {file_service} from "@/api/adminService";
import Message from "ant-design-vue/lib/message";
import axios from "axios";
import {sliceFile,getFileMd5} from "@/utils/fileUtil";

export default {
    name: "FilePartUpload",
    emits: [
        "change",
        "delete",
        "update:value"
    ],
    props: {
        names: {
            type: String,
            default: '上传'
        },
        value: {
            type: String,
        },
        size: {
            type: Number,
            default: 6,
        },
        count: {
            type: Number,
            default: 1,
        },
        showBtn: {
            type: Boolean,
            default: true,
        },
        isPdf: {
            type: Boolean,
            default: false,
        },
        isZip: {
            type: Boolean,
            default: false,
        },
        isPdfImg: {
            type: Boolean,
            default: false,
        },
        dataId: {
            type: Boolean,
        }
    },
    setup(props, {emit}) {
        const action = ref((file_service.partUpload));
        const loading = ref(false);
        const fileLists = ref([]);
        const {value} = toRefs(props);
        const fileNamevalue = ref('');
        const finishCount = ref(0);
        const fileInfo = ref({});
        watch(
            value,
            (value) => {
                if (value) {
                    fileLists.value = value.split(",")
                        .filter(v => v)
                        .map((v) => {
                            let vArray = v.split("|")
                            return {
                                uid: v,
                                name: vArray[1],
                                status: "done",
                                url: v,
                            };
                        });
                } else {
                    fileLists.value = [];
                }
            },
            {immediate: true}
        );
        const percent = computed(() => {
            if (!fileInfo.value.totalChunks){
                return 0
            }
            // 总分片加一是 加上 最后的合并
            return (finishCount.value / (fileInfo.value.totalChunks+1) * 100).toFixed(0)
        })
        const beforeUpload = (file) => {
            return new Promise((resolve, reject) => {
                if (file.size > props.size * 1024 * 1024) {
                    message.warning("请上传不超过" + props.size + "M的文件");
                    reject();
                }
                if (props.isPdf && ['application/pdf'].indexOf(file.type) < 0) {
                    message.warning("请上传pdf");
                    reject();
                }
                if (props.isPdfImg && ['application/pdf', "image/jpg", "image/jpeg", "image/png", "image/gif"].indexOf(file.type) < 0) {
                    message.warning("请上传pdf或者图片");
                    reject();
                }
                if (props.isZip) {
                    let str = file.name.substring(file.name.lastIndexOf(".") + 1)
                    // console.log('file', ['zip', 'rar', '7z', 'taz'].indexOf(str), str)
                    if (['zip', 'rar', '7z', 'taz'].indexOf(str) > 0) {
                        message.warning("不允许上传压缩包！");
                        reject();
                    }
                }
                /*const fileMd5 = getFileMd5(file);
                fileInfo.md5 = fileMd5*/
                // checkIsUploaded(fileMd5)
                finishCount.value=0;
                resolve();
            });
        };
        const onPreview = (file) => {
            /*axios({
                methods: 'get',
                url: file_service.download + file.uid,
            }).then(() => {
                const link = document.createElement("a"); // 创建a标签
                link.href = file_service.download + file.uid;
                link.download = file.name;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            })*/
            const link = document.createElement("a"); // 创建a标签
            link.href = file_service.download + file.uid;
            link.download = file.name;
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };
        const onChange = ({file, fileList}) => {
            // fileLists.value = fileList;
            switch (file.status) {
                case "uploading":
                    loading.value = true;
                    break;
                case "done":
                    loading.value = false;
                    break;
                case "removed":
                    loading.value = false;
                    updateValue(fileList);
                    emit("delete", file);
                    break;
                case "error":
                    loading.value = false;
                    message.warning("上传失败");
                    // fileList.pop();
                    // fileLists.value = fileList;
                    break;
                default:
                    loading.value = false;
                    break;
            }
        };

        function genPromises(chunks, action) {
            const promiseArr = [];
            for (let index = 0; index < chunks.length; index++) {
                const promise = axios.create({}).post(action, chunks[index])
                .then(() => {
                    finishCount.value++;
                    console.log("完成进度", finishCount.value, chunks.length)
                    chunks[index].finish = true
                })

                promiseArr.push(promise)
            }
            return promiseArr;
        }

        // async function checkIsUploaded(fileMd5) {
        //     return await axios.get("/checkUploaded?md5="+fileMd5)
        // }

        function mergeChunk(chunk) {
            return axios.create({}).post(file_service.merge,chunk)
        }

        const customRequest = async (info) => {
            const {action, file} = info;
            const fileMd5 = await getFileMd5(file);
            /*await checkIsUploaded(fileMd5).then((resp)=>{
                if (resp.isUploaded){
                    updateValue([...fileLists.value, { uid: resp.fileId }]);
                    emit("uploadSuccess",resp.fileId, props.dataId);
                }
            });*/
            const chunks = await sliceFile(file, 20, fileMd5);
            fileInfo.value = {
                fileName:file.name,
                md5:fileMd5,
                totalChunks:chunks.length,
                totalSize: file.size,
            }

            const promiseArr = genPromises(chunks, action);

            Promise.all(promiseArr)
            .then(async () => {
                await mergeChunk(fileInfo.value).then(resp=>{
                    finishCount.value++
                    loading.value = false
                    let value = resp.data.data
                    emit("update:value", value);
                    emit("change", value);
                })
            })
            .catch((err) => {
                console.log(err)
                Message.warn("上传失败");
            });
        }
        /*const uploadFilesToServer = async (uploadApiUrl, fileName, files) => {
            const fileMd5 = await getFileMd5(files);
            const chunks = await sliceFile(files, 1, fileMd5);
            const promiseArr = [];
            for (let index = 0; index < chunks.length; index++) {
                const promise =
                    axios.post(uploadApiUrl, chunks[index])
                    .then((response) => {
                        console.log(response)
                        // return Promise.resolve(response.data);
                    })
                promiseArr.push(promise)
            }

            console.log(chunks)

            return Promise.all(promiseArr);
            /!*return request
                .post(uploadApiUrl, formData)
                .then((response) => {
                    return Promise.resolve(response.data);
                })
                .catch((error) => {
                    Message.warn("上传失败");
                    return Promise.reject(error);
                })
                .finally(() => {
                    loading.value = false;
                });*!/
        }*/
        const updateValue = (fileList = []) => {
            let value = fileList.map(item => item.uid)
                .join(',')
            emit("update:value", value);
            emit("change", value);
        };

        const removeHandle = (file)=>{
            console.log(file)
            // axios.create().delete(file_service.delete+file.uid,)
        }
        return {
            action,
            loading,
            fileLists,
            beforeUpload,
            onPreview,
            onChange,
            customRequest,
            removeHandle,
            fileNamevalue,
            finishCount,
            fileInfo,
            percent
        };
    },
}
</script>

<style scoped lang="less">
:deep(.ant-upload-list){
    max-width:220px;
}
</style>
